import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Mubashar Nouman </span>
            from <span className="purple"> Lahore, Pakistan.</span>
            <br />I am a Front-end Developer, WordPress Developer & UI/UX Designer.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Videos
            </li>
            <li className="about-activity">
              <ImPointRight /> Eating😂
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "You can't be expert in coding"{" "}
          </p>
          <footer className="blockquote-footer">Mubashar Nouman</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
